<template>
  <div class="mt-4 rounded-[22px] bg-light px-4 py-6 lg:mt-10 lg:rounded lg:px-10">
    <div class="mb-4">
      <div class="flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
        <div class="flex w-full items-center justify-between gap-4 md:w-auto">
          <h3 class="flex items-center justify-start gap-3 text-[18px] font-semibold lg:text-xlx">
                      <span
                          class="inline-flex h-8 w-8 items-center justify-center rounded-full bg-dark text-light leading-none lg:h-12 lg:w-12">
                        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M5.875 5.625V7.5H12.125V5.625C12.125 3.90625 10.7188 2.5 9 2.5C7.24219 2.5 5.875 3.90625 5.875 5.625ZM3.375 7.5V5.625C3.375 2.53906 5.875 0 9 0C12.0859 0 14.625 2.53906 14.625 5.625V7.5H15.25C16.6172 7.5 17.75 8.63281 17.75 10V17.5C17.75 18.9062 16.6172 20 15.25 20H2.75C1.34375 20 0.25 18.9062 0.25 17.5V10C0.25 8.63281 1.34375 7.5 2.75 7.5H3.375Z"
                              fill="currentColor"/>
                        </svg>
                      </span>
            <span>Secure Checkout</span>
          </h3>
          <span class="text-[18px] md:hidden">3/3</span>
        </div>
        <img :src="`${$settings.theme_url}/assets/images/cards.png`" class="h-4 w-auto inline-block"
             alt="card logos, visa, mastercard, amex">
      </div>
    </div>
    <div class="flex flex-col gap-4">
      <Field
          v-if="true"
          v-slot="{ field, errors }"
          v-model="creditCard.cardName"
          label="Name on card"
          rules="required|min:2"
          name="cc-name"
      >
        <div>
          <FieldLabel for="cc-name" :required="true">Name on card</FieldLabel>
          <input
              id="cc-name"
              v-bind="field"
              type="text"
              name="cc-name"
              autocomplete="cc-name"
              class="w-full leading-tight p-4 rounded-sm border bg-white shadow-inner border-light focus:border-transparent focus:ring-2 focus:ring-primary focus:ring-inset focus:bg-white"
              :class="{ 'border-[#F54E4E]': errors.length }"
          />
          <FieldError :errors="errors" help="As appears on the your card"/>
        </div>
      </Field>
      <Field
          v-slot="{ field, errors }"
          label="Card number"
          v-model="creditCard.cardNumber"
          name="cc-number"
          rules="required|credit_card"
      >
        <div>
          <FieldLabel for="cc-number" :required="true">Card Number</FieldLabel>
          <input
              id="cc-number"
              v-bind="field"
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              autocomplete="cc-number"
              name="cc-number"
              class="w-full leading-tight p-4 rounded-sm border bg-white shadow-inner border-light focus:border-transparent focus:ring-2 focus:ring-primary focus:ring-inset focus:bg-white"
              :class="{ 'border-[#F54E4E]': errors.length }"
          />
          <FieldError :errors="errors" help="&nbsp;"/>
        </div>
      </Field>
      <div class="flex gap-3 lg:gap-6">
        <div class="w-1/2">
          <FieldLabel for="cc-exp-month" :required="true">Expiry Date</FieldLabel>
          <div class="flex items-start gap-1">
            <Field
                v-slot="{ field, errors }"
                v-model="creditCard.expiryMonth"
                label="Month"
                name="cc-exp-month"
                :rules="{required: true, min: 1, max:2, month: true}"
                as="div"
            >
              <input
                  id="cc-exp-month"
                  name="cc-exp-month"
                  v-bind="field"
                  placeholder="MM"
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  maxlength="2"
                  autocomplete="cc-exp-month"
                  class="w-full leading-tight p-4 rounded-sm border bg-white shadow-inner border-light focus:border-transparent focus:ring-2 focus:ring-primary focus:ring-inset focus:bg-white"
                  :class="{ 'border-[#F54E4E]': errors.length }"
              />
              <FieldError :errors="errors"/>
            </Field>
            <div class="relative mt-4">/</div>
            <Field
                v-slot="{ field, errors }"
                label="Year"
                name="cc-exp-year"
                :rules="{ required: true, min: 2, max:2, max_value: currentYear + 15, min_value: currentYear}"
                as="div"
                v-model="creditCard.expiryYear"
            >
              <input
                  id="cc-exp-year"
                  v-bind="field"
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  placeholder="YY"
                  maxlength="2"
                  autocomplete="cc-exp-year"
                  class="w-full leading-tight p-4 rounded-sm border bg-white shadow-inner border-light focus:border-transparent focus:ring-2 focus:ring-primary focus:ring-inset focus:bg-white"
                  :class="{ 'border-[#F54E4E]': errors.length }"
              />
              <FieldError :errors="errors"/>
            </Field>
          </div>
        </div>
        <Field
            v-slot="{ field, errors }"
            label="CVV"
            name="cc-csc"
            rules="required|min:3|max:4"
            v-model="creditCard.cardSecurityNumber"
        >
          <div class="customer-field mb-2 w-1/2">
            <FieldLabel for="cvv" :required="true">CCV number</FieldLabel>
            <div class="flex-grow">
              <input
                  id="cc-csc"
                  v-bind="field"
                  type="text"
                  inputmode="numeric"
                  autocomplete="cc-csc"
                  pattern="[0-9]*"
                  maxlength="4"
                  class="w-full leading-tight p-4 rounded-sm border bg-white shadow-inner border-light focus:border-transparent focus:ring-2 focus:ring-primary focus:ring-inset focus:bg-white"
                  :class="{ 'border-[#F54E4E]': errors.length }"
              />
              <FieldError :errors="errors"/>
            </div>
          </div>
        </Field>
      </div>
    </div>
  </div>
</template>
<script setup>
import {Field } from 'vee-validate';
import FieldError from "../components/FieldError.vue"
import FieldLabel from "./../components/FieldLabel"
</script>
<script>
import {mapWritableState} from "pinia";
import useStore from "../store";
import DatesMixin from "../mixins/dates";

export default {
  mixins: [DatesMixin],
  computed: {
    ...mapWritableState(useStore, [
      "creditCard",
    ]),
  }
}
</script>
